export enum EEnv {
  dev = 'dev',
  stage = 'stage',
  prod = 'prod',
}
